import {
  ACTIVE_STATUS,
  ESCALATION_STATUS,
  COMPLETED_STATUS,
  WAITING_FOR_INSPECTION,
  WAITING_FOR_SHIPPING,
} from "../../../components/contractListItem/constants";
import { ECONTRACT_STATUS } from "../../../enums";

export const CONTRACT_STATUS_TITLE = {
  [ECONTRACT_STATUS.CREATED]: ACTIVE_STATUS,
  [ECONTRACT_STATUS.COMPLETED]: COMPLETED_STATUS,
  [ECONTRACT_STATUS.WAITING_FOR_DELIVERY]: WAITING_FOR_SHIPPING,
  [ECONTRACT_STATUS.ITEM_INSPECTION]: WAITING_FOR_INSPECTION,
  [ECONTRACT_STATUS.INSPECTION_ESCALATION]: ESCALATION_STATUS,
  [ECONTRACT_STATUS.DELIVERY_ESCALATION]: ESCALATION_STATUS,
};

export const BANK_INFO = "الحساب البنكى";
